const classificacaoTributaria = Object.freeze([
    {
        "content": "Nenhum",
        "id": "0"
    },
    {
        "content": "010001 - Operações do FGTS não realizadas pela Caixa Econômica Federal",
        "id": "010001"
    },
    {
        "content": "010002 - Operações do serviço financeiro",
        "id": "010002"
    },
    {
        "content": "010003 - Intermediação de planos de assistência à saúde",
        "id": "010003"
    },
    {
        "content": "200001 - Serviços de transporte de bens até as zonas de processamento de exportação e bens exportados a partir das zonas de processamento de exportação",
        "id": "200001"
    },
    {
        "content": "200004 - Fornecimento de dispositivos médicos (Anexo XII)",
        "id": "200004"
    },
    {
        "content": "200005 - Fornecimento de dispositivos médicos para órgãos da administração pública e entidades de saúde imunes (Anexo IV)",
        "id": "200005"
    },
    {
        "content": "200006 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XII)",
        "id": "200006"
    },
    {
        "content": "200007 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo XIII)",
        "id": "200007"
    },
    {
        "content": "200008 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência adquiridos por órgãos da administração pública (Anexo V)",
        "id": "200008"
    },
    {
        "content": "200016 - Prestação de serviços de pesquisa e desenvolvimento por Instituição Científica, Tecnológica e de Inovação (ICT)",
        "id": "200016"
    },
    {
        "content": "200017 - Operações relacionadas ao FGTS",
        "id": "200017"
    },
    {
        "content": "200019 - Importador dos serviços financeiros contribuinte",
        "id": "200019"
    },
    {
        "content": "200020 - Operação praticada por sociedades cooperativas optantes por regime específico do IBS e CBS",
        "id": "200020"
    },
    {
        "content": "200021 - Serviços de transporte público coletivo de passageiros ferroviário e hidroviário",
        "id": "200021"
    },
    {
        "content": "200025 - Fornecimento dos serviços de educação relacionados ao Programa Universidade para Todos (Prouni)",
        "id": "200025"
    },
    {
        "content": "200026 - Locação de imóveis localizados nas zonas reabilitadas",
        "id": "200026"
    },
    {
        "content": "200027 - Operações de locação, cessão onerosa e arrendamento de bens imóveis",
        "id": "200027"
    },
    {
        "content": "200028 - Fornecimento dos serviços de educação (Anexo II)",
        "id": "200028"
    },
    {
        "content": "200029 - Fornecimento dos serviços de saúde humana (Anexo III)",
        "id": "200029"
    },
    {
        "content": "200030 - Venda dos dispositivos médicos (Anexo IV)",
        "id": "200030"
    },
    {
        "content": "200031 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo V)",
        "id": "200031"
    },
    {
        "content": "200037 - Fornecimento de serviços ambientais de conservação ou recuperação da vegetação nativa",
        "id": "200037"
    },
    {
        "content": "200038 - Fornecimento dos insumos agropecuários e aquícolas (Anexo IX)",
        "id": "200038"
    },
    {
        "content": "200039 - Fornecimento dos bens e serviços relacionados com produções nacionais artísticas, culturais, de eventos, jornalísticas e audiovisuais (Anexo X)",
        "id": "200039"
    },
    {
        "content": "200040 - Fornecimento de serviços de comunicação institucional à administração pública",
        "id": "200040"
    },
    {
        "content": "200041 - Fornecimento de serviço de educação desportiva (art. 141. I)",
        "id": "200041"
    },
    {
        "content": "200042 - Fornecimento de serviço de gestão e exploração do desporto (art. 141. II)",
        "id": "200042"
    },
    {
        "content": "200043 - Fornecimento à administração pública dos serviços e dos bens relativos à soberania (Anexo XI)",
        "id": "200043"
    },
    {
        "content": "200044 - Operações e prestações de serviços de segurança da informação e segurança cibernética desenv por sociedade que tenha sócio brasileiro (Anexo XI)",
        "id": "200044"
    },
    {
        "content": "200045 - Operações relacionadas a projetos de reabilitação urbana de zonas históricas e de áreas críticas de recuperação e reconversão urbanística",
        "id": "200045"
    },
    {
        "content": "200046 - Operações com bens imóveis",
        "id": "200046"
    },
    {
        "content": "200048 - Hotelaria, Parques de Diversão e Parques Temáticos",
        "id": "200048"
    },
    {
        "content": "200051 - Agências de Turismo",
        "id": "200051"
    },
    {
        "content": "200052 - Prestação de serviços de profissões intelectuais",
        "id": "200052"
    },
    {
        "content": "221001 - Locação, cessão onerosa ou arrendamento de bem imóvel com alíquota sobre a receita bruta",
        "id": "221001"
    },
    {
        "content": "400001 - Fornecimento de serviços de transporte público coletivo de passageiros rodoviário e metroviário",
        "id": "400001"
    },
    {
        "content": "410001 - Fornecimento de bonificações quando constem no documento fiscal e que não dependam de evento posterior",
        "id": "410001"
    },
    {
        "content": "410003 - Doações sem contraprestação em benefício do doador",
        "id": "410003"
    },
    {
        "content": "410004 - Exportações de bens e serviços",
        "id": "410004"
    },
    {
        "content": "410005 - Fornecimentos realizados pela União, pelos Estados, pelo Distrito Federal e pelos Municípios",
        "id": "410005"
    },
    {
        "content": "410006 - Fornecimentos realizados por entidades religiosas e templos de qualquer culto",
        "id": "410006"
    },
    {
        "content": "410007 - Fornecimentos realizados por partidos políticos, entidades sindicais e instituições de educação e de assistência social",
        "id": "410007"
    },
    {
        "content": "410008 - Fornecimentos de livros, jornais, periódicos e do papel destinado a sua impressão",
        "id": "410008"
    },
    {
        "content": "410009 - Fornecimentos de fonogramas e videofonogramas musicais produzidos no Brasil",
        "id": "410009"
    },
    {
        "content": "410010 - Fornecimentos de serviço de comunicação nas modalidades de radiodifusão sonora e de sons e imagens de recepção livre e gratuita",
        "id": "410010"
    },
    {
        "content": "410012 - Fornecimento de condomínio edilício não optante pelo regime regular",
        "id": "410012"
    },
    {
        "content": "410014 - Fornecimento de produtor rural não contribuinte",
        "id": "410014"
    },
    {
        "content": "410015 - Fornecimento por transportador autônomo não contribuinte",
        "id": "410015"
    },
    {
        "content": "410026 - Doação com anulação de crédito",
        "id": "410026"
    },
    {
        "content": "410027 - Exportação de serviço ou de bem imaterial",
        "id": "410027"
    },
    {
        "content": "410028 - Operações com bens imóveis realizadas por pessoas físicas não consideradas contribuintes",
        "id": "410028"
    },
    {
        "content": "410033 - Operações de Fundos de Investimento Imobiliário (FII) e Fundos de Investimento nas Cadeias Produtivas do Agronegócio (Fiagro)",
        "id": "410033"
    },
    {
        "content": "410034 - Operações de fundos de investimento",
        "id": "410034"
    },
    {
        "content": "410035 - Fornecimento realizado por nanoempreendedor",
        "id": "410035"
    },
    {
        "content": "410999 - Operações não onerosas sem previsão de tributação, não especificadas anteriormente",
        "id": "410999"
    },
    {
        "content": "515001 - Operações, sujeitas a diferimento, com insumos agropecuários e aquícolas (Anexo IX)",
        "id": "515001"
    },
    {
        "content": "550016 - Regime Especial de Incentivos para o Desenvolvimento da Infraestrutura",
        "id": "550016"
    },
    {
        "content": "550022 - Regime Especial de Incentivos para a Produção de Hidrogênio de Baixa Emissão de Carbono (Rehidro)",
        "id": "550022"
    },
    {
        "content": "800001 - Fusão, cisão ou incorporação",
        "id": "800001"
    },
    {
        "content": "800002 - Transferência de crédito do associado, inclusive as cooperativas singulares",
        "id": "800002"
    },
    {
        "content": "811001 - Anulação de Crédito por Saídas Imunes/Isentas",
        "id": "811001"
    },
    {
        "content": "811002 - Débitos de notas fiscais não processadas na apuração",
        "id": "811002"
    },
    {
        "content": "811003 - Desenquadramento do Simples Nacional",
        "id": "811003"
    },
    {
        "content": "820001 - Documento com informações de fornecimento de serviços de planos de assistência à saúde",
        "id": "820001"
    },
    {
        "content": "820002 - Documento com informações de fornecimento de serviços de planos de assinstência funerária",
        "id": "820002"
    },
    {
        "content": "820003 - Documento com informações de fornecimento de serviços de planos de assistência à saúde de animais domésticos",
        "id": "820003"
    },
    {
        "content": "820004 - Documento com informações de prestação de serviços de consursos de prognósticos",
        "id": "820004"
    },
    {
        "content": "820006 - Documento com informações de fornecimento de serviços de exploração de via",
        "id": "820006"
    },
    {
        "content": "820007 - Documento com informações de fornecimento de serviços financeiros",
        "id": "820007"
    },
    {
        "content": "820009 - Cobrança relativa a fornecimentos declarados em outro documento",
        "id": "820009"
    }
]);

export default classificacaoTributaria;